(function(){
  var roots=document.querySelectorAll('.aura-lp');
  var rv=document.querySelectorAll('.aura-lp .rv');
  if('IntersectionObserver' in window){
    var vh=window.innerHeight||800;
    var pending=[];
    rv.forEach(function(el){
      if(el.getBoundingClientRect().top<vh){el.classList.add('in');}else{pending.push(el);}
    });
    roots.forEach(function(r){r.classList.add('js');});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1});
    pending.forEach(function(el){io.observe(el);});
  }

  var bar=document.getElementById('aura-sticky'), offer=document.getElementById('offre'), offerVisible=false;
  function update(){
    if(!bar) return;
    var on=window.scrollY>700 && !offerVisible;
    bar.classList.toggle('on',on);
    bar.setAttribute('aria-hidden',on?'false':'true');
    var a=bar.querySelector('a,button'); if(a) a.tabIndex=on?0:-1;
  }
  if(bar){
    if(offer && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){offerVisible=es[0].isIntersecting;update();},{threshold:0}).observe(offer);
    }
    window.addEventListener('scroll',update,{passive:true}); update();
  }

  var main=document.getElementById('pdp-main');
  document.querySelectorAll('.aura-lp .thumb').forEach(function(t){
    t.addEventListener('click',function(){
      if(!main) return;
      main.src=t.getAttribute('data-src');
      main.removeAttribute('srcset');
      main.alt=t.getAttribute('data-alt')||main.alt;
      document.querySelectorAll('.aura-lp .thumb').forEach(function(o){o.setAttribute('aria-pressed','false');});
      t.setAttribute('aria-pressed','true');
    });
  });
})();
